/**
 @param stores
 @param methods
 */
import { Grid, IconButton, Tooltip, Typography } from "@mui/material";
import {
  DeleteOutline,
  ImageOutlined,
  RemoveModerator,
  VerifiedUser,
  ReceiptLong,
  VisibilityOutlined,
  Delete,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import moment from "moment";

const AdminWithDrawlTable = (
  withDrawl = [],
  methods = {},
  openImagePreview
) => {
  // console.log("withDrawlwithDrawl", withDrawl);
  const { navigate, handleApprovedWithDrawl, toggleReceiptModal } = methods;
  const { language, setLanguage, t } = useTranslation();

  const columns = [
    { field: "id", headerName: t("fields.Sno"), width: 90, hidden: true },
    { field: "fullName", headerName: t("fields.fullName"), width: 240 },
    { field: "walletId", headerName: t("fields.WalletID"), width: 240 },
    {
      field: "transactionId",
      headerName: t("fields.transactionId"),
      width: 220,
    },
    { field: "amount", headerName: t("fields.amount"), width: 120 },
    { field: "bankName", headerName: t("fields.bankName"), width: 240 },
    {
      field: "accountNumber",
      headerName: t("fields.accountNumber"),
      width: 240,
    },
    { field: "rfcNumber", headerName: t("fields.rfcNumber"), width: 240 },
    { field: "Retention", headerName: t("fields.retention"), width: 120 },
    { field: "PaidOut", headerName: t("fields.paidOut"), width: 120 },
    { field: "status", headerName: t("fields.status"), width: 120 },
    {
      field: "createdAt",
      headerName: t("fields.createdAt"),
      minWidth: 210,
    },
    {
      field: "actions",
      headerName: t("fields.actions"),
      width: 110,
      renderCell: ({ row }) => {
        const isCancel = row.status === "cancelled";
        const isApproved = row.status === "approved";

        const id = row._id;

        const amount = row.amount;
        const fullName = row?.fullName;

        return (
          <Grid container>
            {isCancel ? (
              <>
                <Grid>
                  <Tooltip title="Cancelled already by user" arrow>
                    <IconButton size="small">
                      {/* <Delete /> */}
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 11 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.64987 2.74621C1.58545 2.74621 1.53928 2.74621 1.49312 2.74621C1.16653 2.74552 0.839595 2.75138 0.51335 2.74242C0.217077 2.73416 -0.00340522 2.48829 3.98181e-05 2.18974C0.00348485 1.89876 0.225345 1.6677 0.517484 1.6522C0.564681 1.64979 0.611878 1.65048 0.65942 1.65048C3.88673 1.65048 7.11438 1.65048 10.3417 1.65186C10.4392 1.65186 10.5419 1.65496 10.6335 1.68388C10.8908 1.7655 11.0352 2.02169 10.9928 2.29477C10.9549 2.5396 10.7396 2.73691 10.4833 2.74277C10.1567 2.75034 9.8301 2.74587 9.50352 2.74621C9.45735 2.74621 9.41153 2.74621 9.34883 2.74621C9.34883 2.81577 9.34883 2.87018 9.34883 2.92459C9.34883 5.05131 9.34987 7.17803 9.34815 9.3051C9.34746 10.0758 8.89616 10.7107 8.18992 10.9215C8.02387 10.9711 7.84404 10.9945 7.67041 10.9952C6.22212 11.001 4.77383 11.0014 3.32553 10.9972C2.36196 10.9948 1.65159 10.2806 1.65021 9.31577C1.6478 7.18905 1.64952 5.06233 1.64952 2.93526C1.64952 2.87982 1.64952 2.82438 1.64952 2.74621H1.64987ZM3.84849 6.31095C3.84849 6.76618 3.84125 7.22176 3.85331 7.677C3.85641 7.79442 3.89913 7.92424 3.96183 8.02411C4.08585 8.22142 4.34423 8.29442 4.56644 8.22383C4.80345 8.14842 4.94987 7.93767 4.95056 7.6584C4.95228 6.76928 4.95193 5.87982 4.94952 4.9907C4.94952 4.91494 4.93747 4.8354 4.91301 4.76377C4.82826 4.51584 4.57677 4.36605 4.32528 4.4053C4.04658 4.44869 3.85193 4.66391 3.84987 4.9449C3.84608 5.40014 3.84883 5.85572 3.84849 6.31095ZM7.15021 6.33712C7.15021 5.88602 7.15641 5.43492 7.14573 4.98382C7.14298 4.86915 7.10853 4.7438 7.05134 4.64463C6.9318 4.43733 6.67618 4.35399 6.44432 4.42045C6.20662 4.48864 6.04918 4.70317 6.04849 4.97693C6.04642 5.87466 6.04677 6.77273 6.04918 7.67045C6.04918 7.74208 6.06227 7.8168 6.08535 7.88464C6.16975 8.13085 6.42297 8.28202 6.67342 8.24277C6.95178 8.19904 7.14642 7.98416 7.14883 7.70282C7.15297 7.24759 7.14987 6.79201 7.15021 6.33678V6.33712Z"
                          fill="#E0221E"
                        />
                        <path
                          d="M5.49033 1.09401C5.11689 1.09401 4.74311 1.09952 4.37001 1.09229C4.10026 1.08712 3.8815 0.87569 3.85119 0.610194C3.82087 0.345731 3.98864 0.0940095 4.24736 0.0206624C4.29215 0.00792137 4.34038 0.00172303 4.38689 0.00172303C5.12964 0.000689968 5.87239 -0.00206485 6.61514 0.00275608C6.89384 0.00447785 7.11501 0.214533 7.14705 0.485538C7.17806 0.749657 7.01063 1.00241 6.75087 1.07404C6.68576 1.09194 6.61514 1.0947 6.54727 1.09504C6.19519 1.09711 5.84311 1.09608 5.49102 1.09608C5.49102 1.09539 5.49102 1.09504 5.49102 1.09435L5.49033 1.09401Z"
                          fill="#E0221E"
                        />
                      </svg>
                    </IconButton>
                  </Tooltip>
                </Grid>
              </>
            ) : isApproved ? (
              <>
                <Grid>
                  <Tooltip title="Approved" arrow>
                    <IconButton size="small">
                      {/* <VerifiedUser className="success" /> */}
                      <svg
                        width="22"
                        height="25"
                        viewBox="0 0 12 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.00897029 3.6454C0.00897029 3.15225 -0.0149091 2.65789 0.0152543 2.16678C0.050026 1.60226 0.45011 1.17274 1.0274 1.0467C2.6202 0.699585 4.21551 0.363889 5.80872 0.0188099C6.06259 -0.0362558 6.29594 0.0420599 6.53264 0.0938625C7.97797 0.410388 9.42037 0.742007 10.8678 1.04997C11.5171 1.18783 11.9985 1.65365 11.9977 2.45516C11.9972 3.25912 12.0035 4.06308 11.9964 4.86704C11.9796 6.67238 11.4912 8.33945 10.4283 9.83112C9.44383 11.2131 8.15015 12.2259 6.55945 12.8813C6.17152 13.0412 5.79322 13.04 5.4078 12.874C2.67424 11.6964 0.935238 9.69977 0.222628 6.8747C0.0969468 6.37584 0.0496071 5.85292 0.0186058 5.33816C-0.0157469 4.77567 0.010646 4.20992 0.010646 3.6454C0.00980816 3.6454 0.00938922 3.6454 0.00855135 3.6454H0.00897029ZM5.48488 6.72337C5.42958 6.67279 5.38727 6.63567 5.34621 6.59692C5.05045 6.31629 4.75635 6.03403 4.45933 5.75462C4.169 5.48133 3.74755 5.47195 3.47231 5.72933C3.18911 5.99365 3.17613 6.41174 3.46645 6.69849C3.9654 7.19122 4.47231 7.67662 4.98593 8.15508C5.28589 8.43449 5.73289 8.41776 6.03159 8.13591C6.31689 7.8667 6.60093 7.59626 6.88413 7.32501C7.64114 6.601 8.39565 5.87454 9.15434 5.15257C9.36381 4.95311 9.44676 4.71775 9.37261 4.44528C9.2331 3.93092 8.59381 3.78245 8.18534 4.1675C7.32946 4.97513 6.47692 5.78603 5.62313 6.59529C5.58249 6.63404 5.5406 6.67157 5.48446 6.72337H5.48488Z"
                          fill="#20BF55"
                        />
                      </svg>
                    </IconButton>
                  </Tooltip>
                </Grid>
                <Grid>
                  <Tooltip title="View Reciept" arrow>
                    <IconButton
                      onClick={() => toggleReceiptModal(row)}
                      size="small"
                    >
                      <ReceiptLong />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </>
            ) : (
              <>
                <Grid>
                  <Tooltip title="Approved WithDrawl" arrow>
                    <IconButton
                      size="small"
                      onClick={() =>
                        handleApprovedWithDrawl(id, amount, fullName)
                      }
                    >
                      {/* <RemoveModerator className="failure" /> */}
                      <svg
                        width="22"
                        height="25"
                        viewBox="0 0 9 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.651086 12.0005C0.499479 11.8273 0.347871 11.6534 0.195514 11.4811C0.129091 11.4061 0.0604178 11.334 0 11.2686C2.72255 8.26379 5.43798 5.26648 8.1474 2.27539C8.36017 2.51108 8.58195 2.7563 8.83076 3.03135C8.80674 3.0475 8.76358 3.06531 8.73394 3.09762C7.82242 4.10169 6.91352 5.10867 5.999 6.10943C5.90556 6.21174 5.85302 6.31074 5.87254 6.45489C5.87854 6.50045 5.87366 6.54809 5.87366 6.62306C5.91419 6.58205 5.94083 6.55596 5.96673 6.52862C6.19676 6.28588 6.41104 6.02161 6.65909 5.80456C7.27078 5.26897 8.1459 5.22962 8.80899 5.68112C9.02139 5.82568 9.06042 6.06303 8.90581 6.27843C8.87954 6.31488 8.84877 6.3476 8.81875 6.38074C7.77814 7.52938 6.73827 8.67884 5.69654 9.82665C5.34116 10.2181 4.93212 10.518 4.45215 10.692C3.69524 10.9666 2.95072 10.945 2.22195 10.5735C2.10186 10.5122 1.99416 10.5341 1.89885 10.6394C1.48981 11.0929 1.08077 11.5465 0.671726 12.0001H0.650336L0.651086 12.0005Z"
                          fill="#E0221E"
                        />
                        <path
                          d="M1.54626 5.09858C1.56614 5.10437 1.56952 5.10645 1.5729 5.10603C1.71625 5.08256 1.78793 4.99074 1.78793 4.83057C1.78793 3.64714 1.7883 2.46371 1.78755 1.28028C1.78755 1.0566 1.83258 0.85529 1.9932 0.702028C2.19059 0.513143 2.41537 0.485804 2.64653 0.595573C2.86832 0.700785 2.96926 0.91121 2.9869 1.17217C2.99028 1.2227 2.98878 1.27365 2.98878 1.3246C2.98878 2.42602 2.98878 3.52743 2.98878 4.62885C2.98878 4.67524 2.98878 4.72163 2.98878 4.78625C3.0612 4.7701 3.12537 4.75933 3.18767 4.73986C3.20493 4.73448 3.22294 4.70548 3.22745 4.68394C3.2342 4.65039 3.2297 4.61394 3.2297 4.57873C3.2297 3.30541 3.23007 2.03209 3.2297 0.758776C3.2297 0.545038 3.26572 0.346626 3.41395 0.193364C3.60984 -0.0096046 3.838 -0.0510268 4.08118 0.0608131C4.30971 0.16644 4.40991 0.379349 4.43055 0.643209C4.4343 0.689601 4.43242 0.736823 4.43242 0.78363C4.43242 1.95919 4.43242 3.13475 4.43242 4.31073C4.43242 4.35671 4.43242 4.4031 4.43242 4.45778C4.49172 4.44618 4.53975 4.43375 4.58816 4.42837C4.65421 4.42091 4.67297 4.38404 4.67259 4.31238C4.66959 3.92177 4.67109 3.53116 4.67109 3.14055C4.67109 2.51549 4.67109 1.89084 4.67109 1.26578C4.67109 0.999025 4.7484 0.772446 4.96455 0.631196C5.37809 0.361124 5.86181 0.661849 5.87307 1.19785C5.88095 1.55698 5.87495 1.91653 5.87495 2.27566C5.87495 2.8187 5.87382 3.36133 5.87607 3.90438C5.87607 3.97935 5.85956 4.03403 5.80965 4.08912C4.2219 5.83838 2.63565 7.5897 1.0494 9.34021C1.02501 9.36713 0.998742 9.39281 0.96722 9.42553C0.758948 9.10783 0.607715 8.76816 0.50114 8.40282C0.393063 8.03168 0.347656 7.65059 0.347656 7.26164C0.348032 5.44155 0.347656 3.62146 0.348032 1.80137C0.348032 1.43064 0.509771 1.17217 0.789344 1.08974C1.17212 0.976657 1.53162 1.26413 1.54325 1.70154C1.55113 2.00186 1.54626 2.30299 1.54626 2.60372C1.54626 3.39281 1.54626 4.18149 1.54626 4.97058C1.54626 5.01325 1.54626 5.0555 1.54626 5.09899V5.09858Z"
                          fill="#E0221E"
                        />
                      </svg>
                    </IconButton>
                  </Tooltip>
                </Grid>
              </>
            )}
          </Grid>
        );
      },
    },
  ];

  const rows =
    withDrawl.length === 0
      ? []
      : [
          ...withDrawl.map((item, index) => ({
            id: index + 1,
            // fullName: item?.userId?.name || item?.adminId?.firstName + " " +item?.adminId?.lastName,
            fullName: item?.fullName,
            transactionId: item?.transactionId,
            walletId: item?.walletId,
            amount: item?.amount,
            bankName: item?.bankName,
            accountNumber: item?.accountNo,
            rfcNumber: item?.rfcNo,
            Retention: "10%",
            status: item?.status,
            createdAt: moment(item?.createdAt).format("MMMM Do YYYY HH:mm"),
            _id: item?._id,
            file: item.file,
          })),
        ];

  return { columns, rows };
};

export default AdminWithDrawlTable;
